'use client';

import { createContext, useContext, type ReactNode } from 'react';

/**
 * Sets `data-app-theme` on native `<dialog>` surfaces so top-layer modals keep
 * the same CSS variables as the route shell (see `globals.css`).
 */
export type DialogSurfaceTheme =
  | 'public'
  | 'private'
  | 'auth'
  | 'auth-login'
  /** Shelter adopt-quiz palette — pair with `surfaceThemeStyle` (`--theme-*` from catalog). */
  | 'adopt-quiz';

const DialogSurfaceThemeContext = createContext<DialogSurfaceTheme | null>(null);

export function DialogSurfaceThemeProvider({
  value,
  children,
}: {
  value: DialogSurfaceTheme;
  children: ReactNode;
}) {
  return (
    <DialogSurfaceThemeContext.Provider value={value}>
      {children}
    </DialogSurfaceThemeContext.Provider>
  );
}

export function useOptionalDialogSurfaceTheme(): DialogSurfaceTheme | null {
  return useContext(DialogSurfaceThemeContext);
}
